export default __webpack_public_path__ + "assets/images/56bda66e160a4cb6ddd1db79edb3c448.jpg";